import "./style.scss";
import { Link, useNavigate } from "react-router-dom";
import Scanner from "../img/profile.svg?react";
import Logout from "../img/logout.svg?react";
import { fetchData, removeCookie } from "../../../Helpers";
import { useQuery } from "@tanstack/react-query";
import {
  DETAILS_CACHE_TIME,
  DETAILS_REFETCH_INVERVAL,
  DETAILS_STALE_TIME,
  getUserDetails,
} from "../../../api/consumer";
import { useEffect } from "react";
import NiceModal from "@ebay/nice-modal-react";

export default function UserPanel({ closeNav }) {
  const navigate = useNavigate();

  const { data } = useQuery({
    queryKey: ["user-details"],
    queryFn: getUserDetails,
    refetchInterval: DETAILS_REFETCH_INVERVAL,
    staleTime: DETAILS_STALE_TIME,
    cacheTime: DETAILS_CACHE_TIME,
  });

  useEffect(() => {
    if (data) {
      let tokenUUID;

      try {
        tokenUUID = JSON.parse(getCookie("ICToken")).uuid;
      } catch (e) {
        try {
          tokenUUID = JSON.parse(localStorage.getItem("token")).uuid;
        } catch (e) {
          tokenUUID = null;
        }
      }

      let tutorialSeenTokens = JSON.parse(
        localStorage?.getItem("tutorialSeenUUIDs") ?? "[]"
      );

      // if (
      //   data?.consumer?.isFirstLogin &&
      //   tokenUUID &&
      //   !tutorialSeenTokens?.includes(tokenUUID)
      // ) {
      //   NiceModal.show("entry-points-modal-new");
      // }
    }
  }, [data]);

  return (
    <div className="navigation-user-panel">
      <div className="card-info"></div>

      <div className="bottom-nav">
        <div className="bottom-icon scanner">
          <Link to="/profil/user-data" onClick={() => closeNav()}>
            <Scanner />
          </Link>
        </div>
        {/* <button className="bottom-icon">
          <Message />
        </button> */}
        <button
          aria-label="Logout-button"
          onClick={() => {
            fetchData({
              endpoint: "/consumer/logout",
              payload: {},
              successCallback: () => {
                removeCookie("ICToken");
                localStorage.removeItem("token");
                localStorage.removeItem("loginEvent");
                localStorage.removeItem("urlParams");
                localStorage.removeItem("identify");
                sessionStorage.removeItem("passportData");
                sessionStorage.removeItem("halloween2025_start");
                sessionStorage.removeItem("hideEasterEggBar");
                sessionStorage.removeItem("foundEggs");
                sessionStorage.removeItem("sId");
                sessionStorage.removeItem("loginSource");
                navigate("/logout");
              },
              errorCallback: () => {
                removeCookie("ICToken");
                localStorage.removeItem("token");
                localStorage.removeItem("identify");
                localStorage.removeItem("loginEvent");
                localStorage.removeItem("urlParams");
                sessionStorage.removeItem("passportData");
                sessionStorage.removeItem("halloween2025_start");
                sessionStorage.removeItem("hideEasterEggBar");
                sessionStorage.removeItem("foundEggs");
                sessionStorage.removeItem("sId");
                sessionStorage.removeItem("loginSource");
                navigate("/logout");
              },
            });
          }}
          className="bottom-icon"
        >
          <Logout />
        </button>
      </div>
    </div>
  );
}
